import { z } from 'zod'
import { create } from '@bufbuild/protobuf'

import type { ConsentRequest } from '@jotta/grpc-connect-openapi/consent'
import { ConsentRequestSchema } from '@jotta/grpc-connect-openapi/consent'

type LegacyCookieCategory =
  | 'cookie_cat_necessary'
  | 'cookie_cat_functional'
  | 'cookie_cat_statistic'
  | 'cookie_cat_marketing'
  | 'cookie_cat_unclassified'

const CategorySchema = z.string()
const LegacyConsentSchema = z.object({
  consent_url: z.string().optional(),
  user_uid: z.string().optional(),
  consents_approved: z.array(CategorySchema),
  consents_denied: z.array(CategorySchema),
})
type LegacyConsent = z.infer<typeof LegacyConsentSchema>

function hasConsented(consent: LegacyConsent, category: LegacyCookieCategory) {
  return consent.consents_approved.includes(category)
    ? true
    : consent.consents_denied.includes(category)
      ? false
      : undefined
}

function convertLegacyConsent(consent: LegacyConsent): ConsentRequest {
  return create(ConsentRequestSchema, {
    url: consent.consent_url,
    clientUserId: consent.user_uid,
    functionalCookieConsent: hasConsented(consent, 'cookie_cat_functional'),
    marketingCookieConsent: hasConsented(consent, 'cookie_cat_marketing'),
    necessaryCookieConsent: hasConsented(consent, 'cookie_cat_necessary'),
    statisticalCookieConsent: hasConsented(consent, 'cookie_cat_statistic'),
  })
}

export function decodeLegacyConsentCookie(cookie: string) {
  try {
    const decodedCookie = decodeURIComponent(cookie)
      .replace(/%28/g, '(')
      .replace(/%29/g, ')')
    return convertLegacyConsent(
      LegacyConsentSchema.parse(JSON.parse(decodedCookie)),
    )
  } catch (e) {
    reportError(e)
  }
}
